import api from './api';
import { Depense } from '../types';

export const depenseService = {
  getAll: () => api.get<Depense[]>('/api/depenses').then((r) => r.data),
  getByPeriode: (debut: string, fin: string) =>
    api.get<Depense[]>('/api/depenses/periode', { params: { debut, fin } }).then((r) => r.data),
  create: (data: Partial<Depense>) => api.post<Depense>('/api/depenses', data).then((r) => r.data),
  delete: (id: number) => api.delete(`/api/depenses/${id}`),
};
